import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RecipeLite } from '@shared/models/recipe/recipe-lite.model';
import { RecipeService } from '@services/recipe/recipe.service';
import { MatButtonModule } from '@angular/material/button';

export interface EditoRecipe {
  summary: string;
}

@Component({
  selector: 'app-edito',
  templateUrl: './edito.component.html',
  styleUrls: ['./edito.component.scss'],
  imports: [TranslateModule, EditorComponent, ReactiveFormsModule, MatButtonModule],
})
export class EditoComponent implements OnInit {
  @Input() recipeOriginal: RecipeLite;
  @Output() updateRecipe = new EventEmitter<Partial<RecipeLite>>();
  @Output() formDirtyState = new EventEmitter<boolean>();

  editoForm: FormGroup;
  initOptions = {
    base_url: '/tinymce',
    height: 150,
    statusbar: false,
    suffix: '.min',
    content_css: [] as string[], // as string[] is a fix for tinymce wrong typing
    content_css_cors: false,
    menubar: false,
    advcode_inline: true,
    plugins: 'link lists code',
    toolbar:
      'undo redo | bold italic underline strikethrough | link | alignleft aligncenter alignright alignjustify' +
      ' | numlist bullist outdent indent | h1 | h2 | h3 | h4 | h5 | code',
  };

  constructor(
    private fb: FormBuilder,
    private recipeService: RecipeService,
  ) {
    this.editoForm = this.fb.group<EditoRecipe>({
      summary: '',
    });
  }

  ngOnInit(): void {
    if (this.recipeOriginal) {
      this.editoForm.patchValue({
        summary: this.recipeOriginal.summary ?? '',
      });
    }
    this.editoForm.valueChanges.subscribe(() => {
      this.formDirtyState.emit(this.editoForm.dirty);
    });
  }

  save(): void {
    this.updateRecipe.emit(this.recipeService.convertEditoFormToRecipeLite(this.recipeOriginal, this.editoForm.value));
    this.editoForm.markAsPristine();
    this.formDirtyState.emit(this.editoForm.dirty);
  }

  reset(): void {
    if (this.recipeOriginal) {
      this.editoForm.markAsPristine();
      this.editoForm.patchValue({
        summary: this.recipeOriginal.summary ?? '',
      });
      this.formDirtyState.emit(this.editoForm.dirty);
    }
  }
}
